import { MutableRefObject, type ReactNode, type ReactElement, isValidElement } from 'react';

export type ActionBarType = 'page' | 'modal' | 'modal-vertical' | 'mobile';

interface BaseActionBarProps {
    /** ActionBar тип */
    type?: ActionBarType;
    /** wrapperRef для получения высоты экшен бара */
    wrapperRef?: MutableRefObject<number | undefined>;
    /**
     * Дополнительный контент размещаемый в контейнере над кнопками для вертикального отображения, либо в контейнере
     * между кнопками для горизонтального отображения
     */
    additionalContent?: ReactNode;
    /** primary кнопки */
    primaryActions?: ReactNode;
    /** secondary кнопки */
    secondaryActions?: ReactNode;
}

type ActionBarDividerProgressProps =
    | {
          type: 'mobile';
          /** Показывать ли разделитель */
          showDivider?: boolean;
          /** Показывать ли прогресс бар */
          showProgress?: never;
      }
    | { type?: Exclude<ActionBarType, 'mobile'>; showDivider?: boolean; showProgress?: never }
    | { type?: Exclude<ActionBarType, 'mobile'>; showDivider?: never; showProgress?: ReactNode };

export type ActionBarProps = BaseActionBarProps & ActionBarDividerProgressProps;

export const isActionBarComponent = (component: ReactNode): component is ReactElement<ActionBarProps> => {
    return (
        isValidElement(component) &&
        typeof component.type === 'function' &&
        'isActionBar' in (component?.type as object)
    );
};
